<div>
  <a class="bottom-link" [routerLink]="['/help/privacy']" trans="component.privacy_statement_link.link_text"></a>
</div>
